<template>
  <div>
    <v-radio-group :value="true" row dense>
      <v-radio label="Sessions Not Billed" :value="true"></v-radio>
    </v-radio-group>
    <v-divider class="my-5"></v-divider>
    <sessions-not-billed></sessions-not-billed>
  </div>
</template>
<script>
import SessionsNotBilled from "./sessions-not-billed.vue";
export default {
  components: { SessionsNotBilled },
};
</script>
